import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 9v12m-8 -8a8 8 0 0 0 16 0m1 0h-2m-14 0h-2","key":"svg-0"}],["path",{"d":"M9 6a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-1"}]]

const IconAnchor = createReactComponent('outline', 'anchor', 'Anchor', __iconNode);

export default IconAnchor;